import { TutorDataType } from "./types";

export const CLIENT_PAGES = {
  JOBS: "jobs",
  JOB_APPLY: "job-apply",
  SUBJECTS: "subjects",
  PERSONAL_INFO: "personal-info",
  LOCATION_INFO: "location-info",
  VERIFICATION: "verification",
  CREDENTIALS: "credentials",
  EDUCATION_HISTORY: "education-history",
  WORK_HISTORY: "work-history",
  TEACHING_PROFILE: "teaching-profile",
  PROFILE_PHOTO: "profile-photo",
  SCHEDULE_INFO: "schedule-info",
  GUARANTOR_INFO: "guarantor-info",
  UPLOAD_PROOF: "upload-proof",
  PAYMENT_INFO: "payment-info",
  POST_APPLICATION_1: "post-application-1",
  POST_APPLICATION_2: "post-application-2",
  COMPLETE_ONBOARDING: "complete-onboarding",
  VIDEO_SUBMISSION: "video-submission",
  TEACHING_DEMO: "teaching-demo",
};

export type ClientSubjectType = {
  educationWorkHistory?: {
    educations: Array<{
      school: string;
      country: string;
      course: string;
      degree: string;
      speciality: string;
      startYear: string;
      endYear: string;
      grade: string;
    }>;
    workHistories?: Array<{
      company: string;
      role: string;
      isTeachingRole: boolean;
      startYear: string;
      endYear: string;
      isCurrent: boolean;
      showOnProfile: boolean;
    }>;
    guarantors: Array<{
      title: string;
      fullName: string;
      email: string;
      occupation: string;
      phone: string;
      company: string;
      relationship: string;
    }>;
  };
  subjectData?: {
    tutorSubjects: any[];
    tuteriaSubjects: any[];
    groups: any[];
    jobSubjects: any[];
  };
  tutorInfo?: TutorDataType;
  staticData: {
    regions: any[];
    countries: any[];
    supportedCountries: any[];
    educationData?: {
      degree_data: Array<{ name: string; abbrev: string; rank: number }>;
      grade_data: string[];
      specialities: string[];
      sources?: string[];
      languages?: string[];
    };
    pricing: any[];
  };
  jobs: any[];
};

export type ClientPageTypes = ClientSubjectType;
